// extracted by mini-css-extract-plugin
module.exports = {"progress-bar":"point-progress-bar_progress-bar__1gXYz","circle":"point-progress-bar_circle__2enp_","filled":"point-progress-bar_filled__Wcu9A"};